import React, { useEffect, useState } from "react";
import { ChevronDown, Package } from "lucide-react";

export default function OrderHistoryPage({ user }) {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const API_BASE_URL = window._config?.apiBaseUrl || "";
  const DATABASE_KEY = window._config?.databaseKey || "";
const usrId = sessionStorage.getItem('vid'); 
useEffect(() => {
  const vid = sessionStorage.getItem("vid");
  if (!vid) return;

  fetch(
    `${API_BASE_URL}/GetLikedItemList?Vid=${vid}&databaseKey=${DATABASE_KEY}`
  )
    .then((res) => res.json())
    .then((data) => {
      const rows = data?.GetLikedItemList?.Table1 || [];

      // Group orders by PoId
      const groupedOrders = Object.values(
        rows.reduce((acc, row) => {
          if (!acc[row.PoId]) {
            acc[row.PoId] = {
              PoId: row.PoId,
              Podate: row.Podate,
              DeliveryDate: row.DeliveryDate,
              OrderTotal: row.OrderTotal,
              amountPaid: row.amountPaid,
              Paymode: row.Paymode,
              ReferenceNo: row.ReferenceNo,
              Status: row.Status,
              items: []
            };
          }

          acc[row.PoId].items.push({
            Partdesc: row.Partdesc,
            Qty: row.Qty,
            Amount: row.Amount
          });

          return acc;
        }, {})
      );
groupedOrders.sort((a, b) => Number(b.PoId) - Number(a.PoId));
      setOrders(groupedOrders);
    })
    .catch((err) => console.error("Order fetch error:", err));
}, [user]);


  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Confirmed";
      case 2:
        return "Shipped";
      case 3:
        return "Delivered";
      default:
        return "Pending";
    }
  };

  return (
  <div className="relative min-h-screen px-4 py-10 overflow-hidden bg-gradient-to-br from-pink-100 via-rose-50 to-teal-100">
    <div className="max-w-4xl p-8 mx-auto border shadow-2xl backdrop-blur-lg bg-white/70 rounded-3xl border-white/40">

      {/* Page Title */}
      <h1 className="mb-4 text-2xl font-semibold text-gray-800">
        Order History
      </h1>

      {orders.length === 0 ? (
        <div className="p-10 text-center bg-white shadow-sm rounded-2xl">
          <Package className="w-12 h-12 mx-auto mb-2 text-gray-300" />
          <p className="text-sm text-gray-500">
            You have not placed any orders yet.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => {
            const isOpen = expanded === order.PoId;

            return (
              <div
                key={order.PoId}
                className="transition-all duration-300 bg-white border border-gray-200 shadow-sm rounded-2xl hover:shadow-md"
              >
                {/* Header */}
   <div
  onClick={() => setExpanded(isOpen ? null : order.PoId)}
  className="p-5 transition cursor-pointer hover:bg-gray-50"
>

  <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">

    {/* LEFT SECTION */}
    <div className="space-y-1">
      <p className="text-xs tracking-wide text-gray-400 uppercase">
        Order ID
      </p>

      <p className="text-base font-semibold text-gray-800 md:text-lg">
        #{order.PoId}
      </p>

      <p className="text-xs text-gray-400">
        {new Date(order.DeliveryDate).toLocaleDateString("en-GB")}
      </p>
    </div>

    {/* RIGHT SECTION */}
    <div className="flex items-center justify-between gap-3 md:justify-end">

      <div className="flex gap-2">

        <div className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-full">
          Items: {order.items.length}
        </div>

        <div className="px-3 py-1 text-xs font-semibold text-teal-700 bg-teal-100 rounded-full">
          Qty: {order.items.reduce((sum, item) =>
            sum + Number(item.Qty || 0), 0
          )}
        </div>

      </div>

      <ChevronDown
        className={`h-5 w-5 text-gray-400 transition-transform duration-300 ${
          isOpen ? "rotate-180 text-teal-600" : ""
        }`}
      />
    </div>

  </div>
</div>

                {/* Items Section */}
                {isOpen && (
                  <div className="px-6 py-4 space-y-3 border-t bg-gray-50">
                    {order.items.map((item, index) => (
  <div
    key={index}
    className="flex items-center justify-between px-4 py-2 text-sm bg-white rounded-lg shadow-sm"
  >
    <div className="font-medium text-gray-700">
      {item.Partdesc}
    </div>

    <div className="px-3 py-1 text-xs font-semibold text-gray-600 bg-gray-100 rounded-full">
      Qty: {item.Qty}
    </div>
  </div>
))}


                    {/* Payment Info */}
                    <div className="pt-3 mt-3 text-xs text-gray-500 border-t">
                       Ref: {order.ReferenceNo}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  </div>
);

}
